import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-duration-picker-dialog',
  templateUrl: './duration-picker-dialog.component.html',
  styleUrls: ['./duration-picker-dialog.component.css']
})
export class DurationPickerDialogComponent implements OnInit {

  durationForm = this.fb.group({
    hours: ['0', [Validators.required, Validators.min(0), Validators.max(23)]],
    minutes: ['0', [Validators.required, Validators.min(0), Validators.max(59)]]
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DurationPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      hours: number,
      minutes: number,
    },
  ) {
    this.durationForm.controls.hours.setValue(data.hours);
    this.durationForm.controls.minutes.setValue(data.minutes);
  }

  ngOnInit(): void {

  }

  onReset(): void {
    this.durationForm.controls.hours.setValue(0);
    this.durationForm.controls.minutes.setValue(0);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.durationForm.valid) {
      this.dialogRef.close({
        hours: this.durationForm.controls.hours.value,
        minutes: this.durationForm.controls.minutes.value,
      });
    } 
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
